import React, { ReactNode, useState } from 'react'
import classNames from 'classnames'
import Header from '../Header/Header'
import styles from './PageLayout.module.scss'
import Footer from '@algbra/ui/components/Footer/Footer'
import { graphql, useStaticQuery } from 'gatsby'

import AnnouncementBar, {
  AnnouncementBarProps,
} from '@algbra/ui/components/AnnouncementBar/AnnouncementBar'

export type theme = 'corporateHome' | 'corporateFounders'

export type PageLayoutProps = {
  children: ReactNode
  theme?: theme
  announcement?: AnnouncementBarProps
  simpleHeader?: boolean
}

const QUERY_FOOTER = graphql`
  query MyQuery {
    strapiGQL {
      corporateFooter(publicationState: LIVE) {
        slogan
        disclaimer
        links {
          id
          category
          title
          url
          target
        }
        logos {
          name
          url
          image {
            id
            url
            ext
            width
            height
            resolved {
              publicURL
            }
          }
        }
      }
    }
  }
`

const PageLayout = React.forwardRef<HTMLDivElement, PageLayoutProps>(
  (props, ref) => {
    const {
      strapiGQL: { corporateFooter },
    } = useStaticQuery(QUERY_FOOTER)
    const { theme, children } = props

    return (
      <>
        <div id="portal"></div>
        <div
          ref={ref}
          className={classNames(styles.pageLayout, styles[`theme__${theme}`])}
        >
          {theme !== 'corporateHome' && (
            <AnnouncementBar
              title="Algbra Labs bolsters diaspora-focused digital banking leadership with Isbank and RUUT strategic partnership"
              to="https://www.algbra.com/news/algbra-labs-and-moka-united-the-fintech-subsidiary-of-isbank-announce-strategic-partnership-to-launch-ruut-in-the-uk/"
              target="_blank"
              category="Press Release"
            />
          )}
          <Header theme={theme} />
          <div className={styles.pageLayoutContent}>{children}</div>
          <Footer navigationFooter={corporateFooter} isCorporate={true} />
        </div>
      </>
    )
  }
)

export default PageLayout
